import zeefiLogo from '../../components/images/Zeefi-by-Nimble.svg';

const images = {
  logo: zeefiLogo
};

export { images };
